import { ReportAPI, ReportBooksAPI, SetupReportBooksAPI } from "@ai360/core";
import React, { Component } from "react";
import { injectIntl } from "@ai360/core/intl";
import { connect } from "react-redux";
import { getSelectedEventGuidSet } from "~/action-panel/components/event-module/components/event-list/selectors";
import { getSelectedRecGuidSet } from "~/action-panel/components/rec-module/components/rec-list/selectors";
import { IAutoSearchData } from "~/admin/setup/report-books/data/interfaces";
import * as reportTableModel from "~/reports/components/report-table/model";
import {
    PROPS_CROPPING_SEASON_GUID,
    PROPS_INDIVIDUAL_RB,
    PROPS_REPORT_BOOK_GROUP_BY,
} from "~/reports/data/model";
import { messages } from "~/reports/i18n-messages";
import { errorCodeMessages } from "~/i18n-error-messages";
import { DialogBox, DialogBoxFooterType, Loader, LoaderTypes } from "~/core";
import { actions as picklistActions, picklistNames } from "~/core/picklist";
import { ReportOptionsContainer, ReportTable, ReportTypes } from "~/reports/components";
import { IReportTypePage, ISelectReportType } from "~/reports/data/interfaces";
import { getCropDropdown, getReportTypePageList } from "~/reports/data/actions";
import {
    getReportPref,
    getReportTypePages,
    getFields,
    getReportDataByReportType,
} from "~/reports/data/selectors";
import { actions, model, selectors } from "./data";
import { withMasked } from "~/hocs";
import { IReportBookResultInfo } from "~/report-books/data/interface";
import ReportBookReportOptions from "~/reports/reports/report-book-report-options";
import { v4 as uuid } from "uuid";
import "../reports/reports.css";
import "./report-report-books.css";

interface IReportReportBooksProps {
    autoSearchData: IAutoSearchData;
    clearReportBookTypes: boolean;
    deactivateReportBooks: (data: {
        reportBookGuids: string[];
        fieldGuids: string[];
        filterOptions: ReportBooksAPI.IReportBookFilterOptions;
    }) => void;
    fetchPicklistData: (...args) => void;
    getCropDropdown: (payload?: Record<string, any>) => void;
    getReportBooks: (payload: {
        fieldGuids: string[];
        filterOptions: ReportBooksAPI.IReportBookFilterOptions;
    }) => ReportBooksAPI.IReportBookResponse;
    getReportBooksAutoComplete: (payload: {
        fieldGuids: string[];
        filterOptions: ReportBooksAPI.IReportBookFilterOptions;
        searchName: string;
        searchString: string;
    }) => ReportBooksAPI.IReportBookAutoCompleteResponse;
    getReportBooksSelectAll: (payload: {
        fieldGuids: string[];
        filterOptions: ReportBooksAPI.IReportBookFilterOptions;
    }) => ReportBooksAPI.IReportBookResponse;
    getReportBookTypes: () => any;
    getReportTypePageList: (payload: { url: string }) => void;
    loadingReportBook: boolean;
    mergeReportBooks: (data: ReportBooksAPI.IMergeReportBookRequest) => void;
    needs: (...args: any[]) => any;
    onAllReportCreated: () => void;
    refreshReportBooks: string;
    reportBookErrorsMap: Map<string, IReportBookResultInfo>;
    reportBooks: ReportBooksAPI.IReportBookData[];
    reportBooksData: Record<string, any>;
    reportBookTypes: SetupReportBooksAPI.IReportBookTypeRecord[];
    reportPreferences: any;
    reportTypePages: IReportTypePage[];
    selectedFields: ReportAPI.IField[];
    selectedEventGuidSet: Set<string>;
    selectedItems: string[];
    selectedRecGuidSet: Set<string>;
    setReportBookErrorsMap: (data: Map<string, IReportBookResultInfo>) => void;
    totalCount: number;
    intl: any;
}

interface IReportReportBooksState {
    clearReportBookTypes: boolean;
    createReportHubProgress: boolean;
    dateOrderError: boolean;
    filterQuery: ReportBooksAPI.IReportBookFilter;
    initialRequestOptions: { [model.PROPS_FIELD_GUID_LIST]: string[] };
    loadingReportBook: boolean;
    pageSize: number;
    reportBookErrors: IReportBookResultInfo[];
    reportBookRequestCount: number;
    reportBooks: ReportBooksAPI.IReportBookData[];
    reportBookTypes: IReportBookTypeForReportType[];
    reportPreferences: any;
    reportTypePages: IReportTypePage[];
    selectedFieldCountError: boolean;
    selectedItems: string[];
    selectedReportCountError: boolean;
    selectedReportTypeNames: string[];
    selectedReportTypes: string[];
    showReportBookErrorsModal: boolean;
    showValidationModal: boolean;
    skip: number;
    sortOptions: ReportBooksAPI.IReportBookSortOptions;
}

interface IReportBookTypeForReportType extends SetupReportBooksAPI.IReportBookTypeRecord {
    reportTypeDisplayName: string;
    reportTypeName: string;
    reportTypeGuid: string;
}

class ReportReportBooks_ extends Component<IReportReportBooksProps, IReportReportBooksState> {
    constructor(props: IReportReportBooksProps) {
        super(props);
        this.state = {
            clearReportBookTypes: false,
            createReportHubProgress: false,
            dateOrderError: false,
            filterQuery: {},
            initialRequestOptions: { [model.PROPS_FIELD_GUID_LIST]: null },
            loadingReportBook: false,
            pageSize: 50,
            reportBookErrors: [],
            reportBookRequestCount: 0,
            reportBooks: [],
            reportBookTypes: [],
            reportPreferences: props.reportPreferences || {},
            reportTypePages: props.reportTypePages || [],
            selectedFieldCountError: false,
            selectedItems: [],
            selectedReportCountError: false,
            selectedReportTypeNames: [],
            selectedReportTypes: [],
            showReportBookErrorsModal: false,
            showValidationModal: false,
            skip: 0,
            sortOptions: {},
        };
    }

    UNSAFE_componentWillMount() {
        this.props.getReportBookTypes();
        this.props.needs([
            this.props.getReportTypePageList({
                url: ReportAPI.GET_REPORT_TYPE_PAGE_LIST_URL,
            }),
            this.props.fetchPicklistData({
                picklistKey: picklistNames.getPickListCode(picklistNames.PICKLIST_CROPPING_SEASON),
                picklistKey1: picklistNames.getPickListCode(picklistNames.PICKLIST_CROP_PURPOSE),
            }),
            this.props.getCropDropdown(),
        ]);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IReportReportBooksProps) {
        const newState: Partial<IReportReportBooksState> = {};

        if (nextProps.clearReportBookTypes !== this.props.clearReportBookTypes) {
            newState.clearReportBookTypes = nextProps.clearReportBookTypes;

            if (newState.clearReportBookTypes) {
                newState.selectedReportTypeNames = [];
                newState.selectedReportTypes = [];
            }
        }

        if (nextProps.loadingReportBook !== this.state.loadingReportBook) {
            newState.loadingReportBook = nextProps.loadingReportBook;
        }

        if (
            nextProps.refreshReportBooks !== this.props.refreshReportBooks &&
            nextProps.selectedFields?.length > 0
        ) {
            const fieldGuids = nextProps.selectedFields.map((field) => field.fieldGuid);
            const filterOptions = {
                [model.PROPS_REPORT_PAGE_OPTIONS]: {
                    pageSize: this.state.pageSize,
                    skip: 0,
                },
                [model.PROPS_REPORT_SORT_LIST]: this.state.sortOptions,
                [model.PROPS_REPORT_FILTER]: this.state.filterQuery,
            };
            this.props.getReportBooks({ fieldGuids, filterOptions });
        }

        if (nextProps.reportBookErrorsMap?.size > 0) {
            const values = Array.from(nextProps.reportBookErrorsMap.values());
            if (
                values.some((x) => x != null) &&
                values.filter(Boolean).length === this.state.reportBookRequestCount
            ) {
                newState.reportBookErrors = values.filter((x) => x.reportErrorInfo?.length > 0);
            } else {
                newState.reportBookErrors = [];
            }
            newState.showReportBookErrorsModal = newState.reportBookErrors.length > 0;
        }

        if (
            JSON.stringify(nextProps.reportBooks) !== JSON.stringify(this.state.reportBooks) &&
            nextProps.reportBooks != null
        ) {
            newState.reportBooks = nextProps.reportBooks.map((rb) => ({
                ...rb,
                [reportTableModel.PROPS_CUSTOMER_NAME]: rb.customerName,
                [reportTableModel.PROPS_FARM_NAME]: rb.farmName,
                [reportTableModel.PROPS_FIELD_NAME]: rb.fieldName,
                [reportTableModel.PROPS_REPORT_DATE]: rb.createdDate,
                [reportTableModel.PROPS_REPORT_GUID]: rb.batchGuid,
                [reportTableModel.PROPS_REPORT_SEASON]: rb.season,
                [reportTableModel.PROPS_REPORT_STATUS]:
                    rb.status.toLowerCase() === "inprogress"
                        ? "In Progress"
                        : rb.status.toLowerCase() === "statuserror"
                        ? "Status Error"
                        : rb.status,
                [reportTableModel.PROPS_REPORT_TYPE_NAME]: rb.name,
                [reportTableModel.PROPS_REPORT_USER_GUID]: rb.createdByGuid,
            }));
        }

        if (
            JSON.stringify(nextProps.reportBookTypes) !==
                JSON.stringify(this.state.reportBookTypes) &&
            nextProps.reportBookTypes != null
        ) {
            newState.reportBookTypes = nextProps.reportBookTypes.map((rbt) => ({
                ...rbt,
                reportTypeDisplayName: rbt.name,
                reportTypeName: rbt.name,
                reportTypeGuid: rbt.reportBookTypeGuid,
                reportTypeNames: rbt.reportTypeNames,
                reportTypeGuids: rbt.reportTypeGuids,
            }));
        }

        if (nextProps.reportPreferences !== this.props.reportPreferences) {
            newState.reportPreferences = nextProps.reportPreferences;
        }

        if (nextProps.reportTypePages !== this.props.reportTypePages) {
            newState.reportTypePages = nextProps.reportTypePages;
        }

        if (nextProps.selectedFields !== this.props.selectedFields) {
            const fieldGuids = nextProps.selectedFields.map((field) => field.fieldGuid);
            this.props.getReportBooks({ fieldGuids, filterOptions: {} });
        }

        if (
            JSON.stringify(nextProps.selectedItems) !== JSON.stringify(this.state.selectedItems) &&
            nextProps.selectedItems != null
        ) {
            newState.selectedItems = nextProps.selectedItems;
        }

        if (Object.keys(newState).length > 0) {
            this.setState((prevState) => ({ ...prevState, ...newState }));
        }
    }

    render() {
        const {
            createReportHubProgress,
            dateOrderError,
            initialRequestOptions,
            loadingReportBook,
            reportBookErrors,
            reportBooks,
            reportBookTypes,
            reportPreferences,
            reportTypePages,
            selectedFieldCountError,
            selectedItems,
            selectedReportCountError,
            selectedReportTypeNames,
            selectedReportTypes,
            showReportBookErrorsModal,
            showValidationModal,
        } = this.state;
        const { autoSearchData, totalCount } = this.props;
        const { formatMessage } = this.props.intl;

        const {
            onAllReportCreated,
            deactivateReportBooks,
            fetchRecords,
            onFilterChange,
            onGetAutoSearchList,
            onPaginatorChange,
            onSelectAll,
            onSortOption,
        } = this;

        const reportTableProps = {
            autoSearchList: autoSearchData,
            createReportHubProgress: createReportHubProgress,
            initialRequestOptions: initialRequestOptions,
            fetchRecordsAlt: fetchRecords,
            deleteSelectedReportsAlt: deactivateReportBooks,
            hideMergeOption: true,
            getAutoSearchListAlt: onGetAutoSearchList,
            needs: this.props.needs,
            onAllReportCreated: onAllReportCreated,
            onFilterChangeAlt: onFilterChange,
            onPaginatorChangeAlt: onPaginatorChange,
            onSelectAllAlt: onSelectAll,
            onSortOptionAlt: onSortOption,
            records: reportBooks,
            selectedItemList: selectedItems,
            selectAll: selectedItems,
            totalCount,
        };

        return (
            <div className="reports-container report-report-books-container">
                {!loadingReportBook ? null : <Loader type={LoaderTypes.LINE_SCALE} />}
                <div className="reports-options-container">
                    <ReportTypes
                        selectReportType={this.selectReportType}
                        reportTypes={reportBookTypes}
                        selectedReportTypes={selectedReportTypes}
                        formatMessage={formatMessage}
                    />
                    <ReportOptionsContainer
                        alwaysShowDefaultOptions={true}
                        createReport={this.createReport}
                        reportPreferences={reportPreferences}
                        reportTypePages={reportTypePages}
                        selectedReportTypes={selectedReportTypeNames}
                        reportBooks={true}
                    />
                </div>
                <ReportTable {...reportTableProps} />

                <DialogBox
                    className="report-book-data-validation-modal"
                    footerType={DialogBoxFooterType.NONE}
                    isOpen={showValidationModal}
                    onClose={() => this.setState({ showValidationModal: false })}
                    title={"Report Options"}
                >
                    {!selectedFieldCountError ? null : (
                        <div>{formatMessage(messages.selectFieldError)} </div>
                    )}
                    {!selectedReportCountError ? null : (
                        <div>{formatMessage(messages.selectReportBookTypeError)}</div>
                    )}
                    {!dateOrderError ? null : <div>{formatMessage(messages.dateOrderError)}</div>}
                </DialogBox>

                <DialogBox
                    className="report-book-data-error-modal"
                    footerType={DialogBoxFooterType.NONE}
                    isOpen={showReportBookErrorsModal}
                    onClose={() => this.resetReportBookErrorsModal()}
                    title={"Report Book Errors"}
                >
                    {!showReportBookErrorsModal
                        ? null
                        : this.generateErrorInfo(reportBookErrors, formatMessage)}
                </DialogBox>
            </div>
        );
    }

    private createReport = () => {
        const errors = [];
        const newState = {
            dateOrderError: false,
            selectedFieldCountError: this.props.selectedFields?.length === 0,
            selectedReportCountError: this.state.selectedReportTypes?.length === 0,
            showValidationModal: false,
        };
        const reportData = this.props.reportBooksData;
        if (reportData[model.PROPS_START_DATE] && reportData[model.PROPS_END_DATE]) {
            const startDate = new Date(
                reportData[model.PROPS_START_DATE] as string | number | Date
            );
            const endDate = new Date(reportData[model.PROPS_END_DATE] as string | number | Date);
            if (startDate > endDate) {
                newState.dateOrderError = true;
                errors.push(true);
            }
        }
        if (newState.selectedFieldCountError || newState.selectedReportCountError) {
            errors.push(true);
        }
        if (errors.length > 0) {
            newState.showValidationModal = true;
            this.setState(newState);
            return;
        }
        const reportBookErrorsMap = new Map<string, IReportBookResultInfo>();
        let reportBookRequestCount = 0;
        this.props.setReportBookErrorsMap(reportBookErrorsMap);
        this.setState(newState, () => {
            const customerGuids = this.findCustomerIds(this.props.selectedFields);

            const sendMergeRequest = (reportBookType, customerFields) => {
                reportBookRequestCount++;
                const trackingGuid = uuid();
                reportBookErrorsMap.set(trackingGuid, null);
                const data = this.generateMergeReportBookData(
                    reportBookType.reportBookTypeGuid,
                    reportBookType.name,
                    customerFields,
                    trackingGuid
                );
                this.setState({ reportBookRequestCount }, () => {
                    this.props.mergeReportBooks(data);
                    this.props.setReportBookErrorsMap(reportBookErrorsMap);
                });
            };

            for (const customerGuid of customerGuids) {
                const customerFields = this.props.selectedFields
                    .filter((field) => field.customerGuid === customerGuid)
                    .map((field) => ({
                        ...field,
                        acres: Number(field.acres),
                    }));
                for (const reportBookTypeGuid of this.state.selectedReportTypes) {
                    const reportBookType = this.state.reportBookTypes.find(
                        (rbt) => rbt.reportBookTypeGuid === reportBookTypeGuid
                    );
                    if (reportData[PROPS_INDIVIDUAL_RB]) {
                        customerFields.map((customerField) => {
                            sendMergeRequest(reportBookType, [customerField]);
                        });
                    } else {
                        sendMergeRequest(reportBookType, customerFields);
                    }
                }
            }
        });
    };

    private deactivateReportBooks = (reportData) => {
        const fieldGuids = this.fieldGuids();
        const reportBookGuids = reportData.map((rd) => rd.reportBookGuid);

        const filterOptions = {
            [model.PROPS_REPORT_PAGE_OPTIONS]: {
                skip: 0,
            },
            [model.PROPS_REPORT_FILTER]: this.state.filterQuery,
            [model.PROPS_REPORT_SORT_LIST]: this.state.sortOptions,
        };
        this.props.deactivateReportBooks({
            reportBookGuids,
            fieldGuids,
            filterOptions,
        });
    };

    private fetchRecords = () => {
        const fieldGuids = this.fieldGuids();
        this.props.getReportBooks({ fieldGuids, filterOptions: {} });
    };

    private findCustomerIds(selectedFields: ReportAPI.IField[]) {
        const customerGuids = new Set<string>();
        selectedFields.forEach((field) => customerGuids.add(field.customerGuid));
        return Array.from(customerGuids);
    }

    private generateErrorInfo(reportBookErrors: IReportBookResultInfo[], formatMessage) {
        return (
            <div className="report-book-error-info-container">
                {reportBookErrors.map((rbe, idx) => {
                    return (
                        <div key={`err-cont-${idx}`} className="error-info-container">
                            <div className="report-book-company-name">
                                {rbe.customerName} - {rbe.reportBook}
                            </div>
                            {rbe.reportErrorInfo.map((rei, idx2) => {
                                return (
                                    <div
                                        key={`err-info-${idx}-${idx2}`}
                                        className="report-type-error-info-container"
                                    >
                                        <div className="report-type-name">{rei.reportType}</div>
                                        {rei.errorInfo.map((ei, idx3) => {
                                            return (
                                                <div
                                                    key={`err-${idx}-${idx2}-${idx3}`}
                                                    className="error-code-field-config-info-container"
                                                >
                                                    {ei.errorCode !== 0 ? (
                                                        <div className="error-code">
                                                            {formatMessage(
                                                                errorCodeMessages[ei.errorCode]
                                                            ).replace("{codeValue}", "")}
                                                        </div>
                                                    ) : (
                                                        <div className="error-code">
                                                            {formatMessage(
                                                                errorCodeMessages[
                                                                    ei.errorCodeString
                                                                ]
                                                            ).replace("{Field}.", "")}
                                                        </div>
                                                    )}
                                                    {ei.errorCode
                                                        ? ei.fieldAndConfigInfo.map((fci, idx4) => {
                                                              return (
                                                                  <div
                                                                      key={`field-config-${idx}-${idx2}-${idx3}-${idx4}`}
                                                                      className="field-config-info"
                                                                  >
                                                                      {fci}
                                                                  </div>
                                                              );
                                                          })
                                                        : ei.fieldAndConfigInfo.map((fci, idx4) => {
                                                              return (
                                                                  <div
                                                                      key={`field-config-${idx}-${idx2}-${idx3}-${idx4}`}
                                                                      className="field-config-info"
                                                                      dangerouslySetInnerHTML={{
                                                                          __html: fci,
                                                                      }}
                                                                  ></div>
                                                              );
                                                          })}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    }

    private generateMergeReportBookData(
        guid: string,
        name: string,
        customerFields: ReportBooksAPI.IField[],
        trackingGuid: string
    ) {
        const reportData = this.props.reportBooksData;
        const data: ReportBooksAPI.IMergeReportBookRequest = {
            batchGuid: uuid(),
            companyGuid: customerFields[0].customerGuid,
            cropGuid: reportData["cropGuid"] as string,
            endDate: new Date(reportData[model.PROPS_END_DATE] as string | number | Date),
            fields: customerFields,
            reportBookGroupByOption: reportData[PROPS_REPORT_BOOK_GROUP_BY] as string,
            reportBookIndividualOption: reportData[PROPS_INDIVIDUAL_RB] as boolean,
            reportBookTypeGuid: guid,
            reportBookTypeName: name,
            seasonGuid: [reportData[PROPS_CROPPING_SEASON_GUID] as string],
            selectedEventGuids: Array.from(this.props.selectedEventGuidSet),
            selectedRecGuids: Array.from(this.props.selectedRecGuidSet),
            startDate: new Date(reportData[model.PROPS_START_DATE] as string | number | Date),
            trackingGuid,
        };
        return data;
    }

    private onAllReportCreated = () => {
        this.setState({ createReportHubProgress: false });
    };

    private onFilterChange = (searchName, searchString, filterQuery) => {
        this.setState({ filterQuery });
        const sortOptions = this.state.sortOptions ? this.state.sortOptions : null;

        const filterOptions = {
            [model.PROPS_REPORT_PAGE_OPTIONS]: {
                skip: 0,
            },
            [model.PROPS_REPORT_FILTER]: filterQuery,
            [model.PROPS_REPORT_SORT_LIST]: sortOptions,
        };
        const fieldGuids = this.fieldGuids();

        this.props.getReportBooks({ fieldGuids, filterOptions });
    };

    private onGetAutoSearchList = (searchName = "", searchString = "", filter) => {
        const filterOptions = {
            searchName,
            searchString,
            [model.PROPS_REPORT_FILTER]: filter,
        };
        const fieldGuids = this.fieldGuids();

        this.props.getReportBooksAutoComplete({
            fieldGuids,
            filterOptions,
            searchName,
            searchString,
        });
    };

    private onPaginatorChange = ({
        skip = 0,
        pageSize = 50,
        filterQuery = {},
        sortOptions = {},
    }) => {
        this.setState({ skip, pageSize, filterQuery, sortOptions });

        const filterOptions = {
            [model.PROPS_REPORT_PAGE_OPTIONS]: {
                pageSize,
                skip,
            },
            [model.PROPS_REPORT_SORT_LIST]: sortOptions,
            [model.PROPS_REPORT_FILTER]: filterQuery,
        };
        const fieldGuids = this.fieldGuids();

        this.props.getReportBooks({ fieldGuids, filterOptions });
    };

    private onSelectAll = ({ filterQuery, sortOptions }, clearSelectedItems = false) => {
        if (clearSelectedItems) {
            this.setState({ selectedItems: [] });
        } else {
            const filterOptions = {
                [model.PROPS_REPORT_PAGE_OPTIONS]: {
                    pageSize: 256000,
                    skip: 0,
                },
                [model.PROPS_REPORT_SORT_LIST]: sortOptions,
                [model.PROPS_REPORT_FILTER]: filterQuery,
            };
            const fieldGuids = this.fieldGuids();

            this.props.getReportBooksSelectAll({ fieldGuids, filterOptions });
        }
    };

    private onSortOption = ({ sortOptions, filterQuery, pageSize, skip }) => {
        this.setState({ skip, pageSize, filterQuery, sortOptions });

        const filterOptions = {
            [model.PROPS_REPORT_SORT_LIST]: sortOptions,
            [model.PROPS_REPORT_FILTER]: filterQuery,
            [model.PROPS_REPORT_PAGE_OPTIONS]: {
                pageSize,
                skip,
            },
        };
        const fieldGuids = this.fieldGuids();

        this.props.getReportBooks({ fieldGuids, filterOptions });
    };

    private resetReportBookErrorsModal = () => {
        this.props.setReportBookErrorsMap(new Map<string, IReportBookResultInfo>());
        this.setState({
            reportBookErrors: [],
            showReportBookErrorsModal: false,
        });
    };

    private selectReportType = (selected: ISelectReportType) => {
        const { guid } = selected;
        const selectedReportTypes = [...this.state.selectedReportTypes];
        const selectedReportTypeIndex = selectedReportTypes.indexOf(guid);
        const selectedReportTypeNames = [];
        if (selectedReportTypeIndex > -1) {
            selectedReportTypes.splice(selectedReportTypeIndex, 1);
        } else {
            selectedReportTypes.push(guid);
        }
        if (selectedReportTypes.length > 0 && this.state.reportBookTypes.length > 0) {
            const reportNames = this.state.reportBookTypes
                .filter((rbt) => selectedReportTypes.includes(rbt.reportBookTypeGuid))
                .map((rbt) => rbt.name);
            selectedReportTypeNames.push(...reportNames);
        }

        this.setState({
            selectedReportTypeNames,
            selectedReportTypes,
        });
    };

    private fieldGuids() {
        return this.props.selectedFields.map((field) => field.fieldGuid);
    }
}

const mapStateToProps = (state): Partial<IReportReportBooksProps> => ({
    autoSearchData: selectors.getReportBooksAutoComplete(state),
    clearReportBookTypes: selectors.getClearReportBookTypes(state),
    loadingReportBook: selectors.getLoadingReportBook(state),
    refreshReportBooks: selectors.getRefreshReportBooks(state),
    reportBookErrorsMap: selectors.getReportBookErrorsMap(state),
    reportBooks: selectors.getReportBooks(state),
    reportBooksData: getReportDataByReportType(ReportBookReportOptions.reportName)(state),
    reportBookTypes: selectors.getReportBookTypes(state),
    reportPreferences: getReportPref(state),
    reportTypePages: getReportTypePages(state),
    selectedFields: getFields(state),
    selectedEventGuidSet: getSelectedEventGuidSet(state),
    selectedItems: selectors.getReportBooksSelectAll(state),
    selectedRecGuidSet: getSelectedRecGuidSet(state),
    totalCount: selectors.getReportBooksTotalCount(state),
});

const mapDispatchToProps = (dispatch): Partial<IReportReportBooksProps> => ({
    deactivateReportBooks: (payload) => dispatch(actions.deactivateReportBooks(payload)),
    fetchPicklistData: (payload) => picklistActions.fetchPicklistData(payload),
    getCropDropdown: (payload) => getCropDropdown(payload),
    getReportBooks: (payload) => dispatch(actions.getReportBooks(payload)),
    getReportBooksAutoComplete: (payload) => dispatch(actions.getReportBooksAutoComplete(payload)),
    getReportBooksSelectAll: (payload) => dispatch(actions.getReportBooksSelectAll(payload)),
    getReportBookTypes: () => dispatch(actions.getReportBookTypes()),
    getReportTypePageList: (payload) => getReportTypePageList(payload),
    mergeReportBooks: (payload) => dispatch(actions.mergeReportBooks(payload)),
    setReportBookErrorsMap: (payload) => dispatch(actions.setReportBookErrorsMap(payload)),
});

export const ReportReportBooks = injectIntl(
    withMasked(connect(mapStateToProps, mapDispatchToProps)(ReportReportBooks_))
);
